
import Vue from "vue";
import { constants } from "@/utils/constants";

export default Vue.extend({
  name: "StatusCodesTable",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true
  }),
  computed: {
    statusCodes() {
      return constants.statusCodes;
    }
  }
});
